import React from "react";
import { IBannerData } from "../../exports/interfaces";

const EventBanner = (props: { eventBannerData: IBannerData[] }) => {
  return (
    <section className="page-header" style={{ marginTop: "71px" }}>
      <div
        className="page-header-bg"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_strapiUrl}${props?.eventBannerData[0]?.attributes?.Image?.data?.attributes?.url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div className="container">
        <div className="page-header__inner">
          <h2>{props?.eventBannerData[0]?.attributes?.Title}</h2>
          <ul className="thm-breadcrumb list-unstyled">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <span>/</span>
            </li>
            <li className="active">Events</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default EventBanner;
